import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import { RemoteFetchSpecialitiesMaster } from "../../../data/usecases/coverage-reports/remote-fetch-specialities";
import Endpoints from "../../../domain/endpoints";
import Swal from "sweetalert2";
import { FetchState } from "../../../domain/models/fetch-state";
import { FetchMonthlySpecialitiesSummary } from "../../../domain/useages/coverage-reports/fetch-monthly-speciality-summary";
import dayjs, { Dayjs } from "dayjs";
import moment from "moment";
import { MonthlyHQSpecialitySummary } from "../../../domain/models/coverage-reports/monthly-HQ-speciality-summary";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchMonthlyHQSpecialitiesSummaryInterface {
  monthlySpecialitySummaryData: MonthlyHQSpecialitySummary[];
  fetchMonthlySpecialitySummary: Function;
  clearSpecialitySummary: Function;
  specialitySummaryFilters: {
    monthYear: Dayjs | null;
    visitorRole: string;
    customerType_id: number;
    specialities?: string[];
  };
  specialitySummaryStatus: FetchState;
}

const initialStates = {
  monthlySpecialitySummaryData: [],
  specialitySummaryStatus: FetchState.DEFAULT,
  specialitySummaryFilters: {
    monthYear: dayjs(new Date()),
    visitorRole: "HQ_MNG",
    customerType_id: 5,
  },
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchMonthlyHQSpecialitiesSummarySlice: StateCreator<
  FetchMonthlyHQSpecialitiesSummaryInterface
> = (set, get) => ({
  ...initialStates,
  fetchMonthlySpecialitySummary: async () => {
  const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
  const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    set(() => ({ specialitySummaryStatus: FetchState.LOADING }));
    const remoteFetchSpecialitiesMaster: FetchMonthlySpecialitiesSummary =
      new RemoteFetchSpecialitiesMaster(
        `${BASE_URL}${Endpoints.FETCH_MONTHLY_SPECIALITY_SUMMARY}`,

        axiosHttpClient
      );
    let params = {
      month_year: moment(
        (get().specialitySummaryFilters.monthYear as Dayjs).toString()
      ).format("YYYYMM"),
      visitor_role: get().specialitySummaryFilters.visitorRole,
      customer_type_id: get().specialitySummaryFilters.customerType_id,
      specialities: get().specialitySummaryFilters.specialities,
    };
    let result = await remoteFetchSpecialitiesMaster.fetch(params);

    if (result) {
      set(() => ({ monthlySpecialitySummaryData: result }));
      set(() => ({ specialitySummaryStatus: FetchState.SUCCESS }));
    } else {
      Swal.fire({
        icon: "error",
        timer: 3000,
        text: "Error Occured While Fetching Speciality Data",
        customClass: {
          container: "swal2-style",
        },
      });
    }
  },
  clearSpecialitySummary: () => {
    set(() => ({ monthlySpecialitySummaryData: [] }));
  },
});
